const initialState = { projects: [] };
export const projectReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "ADD_PROJECTS":
      return { ...state, projects: payload };
    default:
      return state;
  }
};
